module.exports = __webpack_public_path__ + "static/media/DSC04792.d929a2c9.JPG";